import React from "react";
import PropTypes from "prop-types";

const Pagination = ({ page, totalPages, onPageChange }) => {
    return (
        <div className="pagination-container">
            <button
                onClick={() => onPageChange(page - 1)}
                disabled={page === 1}
            >
                Prev
            </button>

            <span>
                Page {page} of {totalPages}
            </span>

            <button
                onClick={() => onPageChange(page + 1)}
                disabled={page === totalPages}
            >
                Next
            </button>
        </div>
    );
};

Pagination.propTypes = {
    page: PropTypes.number.isRequired,
    totalPages: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
